import { render, staticRenderFns } from "./pedido.vue?vue&type=template&id=0cb3ce5a&scoped=true"
import script from "./pedido.vue?vue&type=script&lang=js"
export * from "./pedido.vue?vue&type=script&lang=js"
import style0 from "./pedido.vue?vue&type=style&index=0&id=0cb3ce5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3ce5a",
  null
  
)

export default component.exports